/**
 * Shared SEO constants for the marketing site. `SITE_ORIGIN` is the canonical
 * production origin; historically it was hardcoded per-file (see
 * `apps/web/pages/_app.tsx`, `apps/web/src/content/article-page.tsx`). New JSON-LD
 * and metadata should import from here.
 */
export const SITE_ORIGIN = "https://mangomap.com";

/** Square-ish brand asset reused for the OG image and schema logo. */
const LOGO_URL = `${SITE_ORIGIN}/app-assets/mangoGIS.png`;

/** Public social profiles, mirrored from the footer (`layout/footer.tsx`). */
export const MANGO_SOCIALS = [
	"https://www.linkedin.com/company/mangomap",
	"https://www.youtube.com/@MangoMap",
];

/** Props for the site-wide Organization JSON-LD (next-seo `OrganizationJsonLd`). */
export const ORGANIZATION = {
	name: "MangoMap",
	url: SITE_ORIGIN,
	logo: LOGO_URL,
	sameAs: MANGO_SOCIALS,
} as const;

/** Publisher fields for Article JSON-LD. */
export const PUBLISHER = {
	name: "MangoMap",
	logo: LOGO_URL,
} as const;

/**
 * Site-wide WebSite JSON-LD. Establishes the site entity/name for SERP display.
 * No `potentialAction`/SearchAction: the marketing site has no public search
 * endpoint, so a sitelinks searchbox would be a false claim.
 */
export const WEBSITE = {
	name: "MangoMap",
	url: SITE_ORIGIN,
} as const;
